import { useEffect, useState } from 'react';
import api from '@/services/api';

/** Refresh cadence, same as the Quote Desk badge. */
export const PENDING_REFRESH_MS = 60_000;

/**
 * #356: the count of pending broker requests beside the sidebar item.
 *
 * A plain effect (no react-query) like QuoteDeskOverdueBadge: the sidebar is
 * rendered without a QueryClient in places, and a badge must never break the
 * menu -- any failure shows nothing.
 */
export function BrokerRequestsPendingBadge({ pollMs = PENDING_REFRESH_MS }: { pollMs?: number }) {
  const [pending, setPending] = useState(0);

  useEffect(() => {
    let active = true;
    const load = () => {
      try {
        Promise.resolve(api.get('/insurers/insurance/broker-requests/', { params: { status: 'pending' } }))
          .then((response) => {
            if (active) setPending(Number(response?.data?.count) || 0);
          })
          .catch(() => {
            if (active) setPending(0);
          });
      } catch {
        if (active) setPending(0);
      }
    };
    load();
    const timer = window.setInterval(load, pollMs);
    window.addEventListener('focus', load);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', load);
    };
  }, [pollMs]);

  if (pending <= 0) return null;
  return (
    <span
      data-testid="broker-requests-pending-badge"
      aria-label={`${pending} pending`}
      className="ml-auto rounded-full bg-amber-600 px-2 py-0.5 text-xs font-semibold text-white"
    >
      {pending > 99 ? '99+' : pending}
    </span>
  );
}

export default BrokerRequestsPendingBadge;
